/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_TitleInputs */

const en_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. Now on Glider.`)
};

const de_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. Jetzt auf Glider.`)
};

const pt_br2_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. Agora na Glider.`)
};

const tr_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. Artık Glider’da.`)
};

const zh_cn2_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise，现已登陆 Glider。`)
};

const zh_hk2_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise，現已登陸 Glider。`)
};

const ko_kr2_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. 이제 Glider에서 만나보세요.`)
};

const ru_ru2_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. Теперь на Glider.`)
};

const es_419_campaigns_mag7_spacex_title = /** @type {(inputs: Campaigns_Mag7_Spacex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strats by Bitwise. Ahora en Glider.`)
};

/**
* | output |
* | --- |
* | "Strats by Bitwise. Now on Glider." |
*
* @param {Campaigns_Mag7_Spacex_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_title = /** @type {((inputs?: Campaigns_Mag7_Spacex_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_title(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_title(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_title(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_title(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_title(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_title(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_title(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_title(inputs)
	return es_419_campaigns_mag7_spacex_title(inputs)
});